import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import Pagination from "@material-ui/lab/Pagination";
import RulePieceHistoryTable from "./RulePieceHistoryTable";

function RulePieceHistory(props) {
    const { t } = useTranslation();
    const {rule_piece} = props

    const [tablePage, setTablePage] = React.useState(1)
    const [rulePieceHistory, setRulePieceHistory] = useState(null)

    useEffect(() => {
        if (rulePieceHistory === null){
                let params = {
                    "page_number": tablePage -1,
                    "page_rows": 10,
                    "environment": rule_piece.environment
                }
                const timer = setTimeout(() => {
                    axios.get("/dash/rule_engine/rule_piece/" + rule_piece.rule_piece_key + "/history", {
                        params: params
                    }).then(response=>{
                        setRulePieceHistory(response.data)
                    }).catch(error=>{
                        setRulePieceHistory(undefined)
                    })
                }, 500);
                return () => {
                    clearTimeout(timer)
                }
        }
    }, [rulePieceHistory, tablePage, rule_piece])

    const handleChangePage = (event, page) => {
		if (tablePage === page) {
			return
		}
        setTablePage(page)
        setRulePieceHistory(null)
	}

    if (rulePieceHistory=== null) {
      return (
        <div style={{display: "flex", height: "160px"}}>
            <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                <CircularProgress />
            </div>
        </div>
      );
    }
    else if (rulePieceHistory === undefined ){
        return (
          <div style={{display: "flex", height: "160px"}}>
              <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                  {t("Informação Indisponível")}
              </div>
          </div>
        )
      }
    else {
        return (
            <div className="internalCardContainer">
                <div>
                    <RulePieceHistoryTable rulePieceHistory={rulePieceHistory.data}/>
                </div>
                <div style={{display:"flex", marginTop: "10px"}}>
                    <Pagination style={{marginLeft:"auto"}} className='pagination' page={tablePage} count={rulePieceHistory['number_of_pages']} onChange={(e,page) => handleChangePage(e, page)} />
                </div>
            </div>
        );
    }
  }

  export default RulePieceHistory;
